import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {UsersState} from '@store/settings/users';
import {createEffectFn} from '@ngneat/effects';
import {interfaceService} from '@store/settings/interface/interface.service';

type SearchInterfaceParams = Partial<UsersState>

export const searchInterfaceEntities = createEffectFn((params$: Observable<SearchInterfaceParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => interfaceService.getInterfaceEntities().pipe(catchError(() => EMPTY)))
  );
});
